<style scoped lang="less">
.boxright {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	margin-top: 10px;
}

.flexx {
	display: flex;
	align-items: center;
}
.classtrainstop {
	height: 5rem;
	padding: 1rem;
	border: 1px solid #ccc;
	border-radius: 5px;
	background-color: #3065bc;
	div {
		margin-right: 1rem;
	}
}

.classtitle {
	margin-top: 1rem;
	width: 100%;
	background-color: #fff;
	box-sizing: border-box;
	padding: 1rem 1rem 0 1rem;
	.classtitle1 {
		width: 35%;
		margin-left: 1.2rem;

		.classtitle1nem {
			font-size: 16px;
			margin-bottom: 15px;
		}

		div {
			font-size: 16px;
			p {
				margin-right: 40px;
			}
		}
	}
	.classtitle2 {
		width: 20%;
		position: absolute;
		right: 0%;
		bottom: 1%;
	}
	.classnametiltle {
		width: 20%;
		font-size: 22px;
		margin-bottom: 4rem;
	}

	.tablists {
		margin-top: 1rem;
		padding: 1rem 1rem 0 1rem;
		border-top: 1px solid #ccc;

		div {
			width: 16%;
			text-align: center;
			height: 2.4rem;
			font-size: 1.2rem;
			cursor: pointer;
		}

		.actives {
			color: #3399ff;
			border-bottom: 4px solid #3399ff;
		}
	}
}

.classdatatotle {
	margin: 1rem 0;
	padding: 1rem;
	background-color: #fff;

	.trainstitle {
		padding-bottom: 10px;
		border-bottom: 1px solid #ccc;
	}

	.trainschat {
		margin-top: 1rem;
		justify-content: space-between;
		.trainschat1 {
			width: 33.3%;
			margin: 0 3rem;
			p {
				margin: 10px;
				font-size: 1rem;
			}
		}

		.trainschat2 {
			width: 33.3%;
			p {
				margin: 10px;
				font-size: 1rem;
			}
		}
	}
}

.responstbilteall {
	.rebuilctlischat {
		width: 40%;
		height: 28rem;
		// border: 1px solid #ff5c00;
		margin-top: 1rem;
	}

	.rebuilctlistdata {
		width: 90%;
		flex-wrap: wrap;
		margin-left: 3rem;
		.rebuilctlistdataitme {
			width: 48%;
			margin: 1rem 1%;
			border: 1px solid #d9d9d9;
			border-radius: 8px;
			box-sizing: border-box;
			padding: 10px;
			align-items: flex-start;
			height: 12rem;
			.cilcle {
				width: 60px;
				height: 60px;
				border-radius: 50%;
				display: flex;
				align-items: center;
				justify-content: center;
				border: 1px solid;
				margin-right: 10px;
				background-color: #81d3f8;
				color: #fff;
				font-size: 1.8rem;
			}

			.stdataitmefont {
				.stdataitmecontent {
					width: 90%;
					font-size: 1rem;
					padding: 0 10px;
					box-sizing: border-box;
				}
				p {
					font-size: 1.5rem;
					margin-bottom: 1rem;
				}
			}
		}
	}
}

.responstbilteall {
	.classreabilct {
		height: 30rem;
		width: 100%;
	}
}

.classreabilctexr {
	height: 70vh;
	padding: 1rem 0;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	overflow-y: scroll;
}

.responsbilict {
	height: 22rem;
	// padding: 1rem 0;
}

.traintimers {
	height: 22rem;
}

/* 修改滚动条的宽度、颜色和圆角 */
.classreabilctexr::-webkit-scrollbar {
	width: 10px;
	height: 10px;
	background-color: #f5f5f5;
	border-radius: 5px;
}
/* 修改滚动条滑块的样式 */
.classreabilctexr::-webkit-scrollbar-thumb {
	background-color: #1abc9c;
	border-radius: 5px;
}
/* 鼠标悬停时修改滑块的样式 */
.classreabilctexr::-webkit-scrollbar-thumb:hover {
	background-color: #a8a8a8;
}
/* 滚动条上方和下方的按钮样式 */
.classreabilctexr::-webkit-scrollbar-button {
	display: none;
}

.el-empty {
	height: 100% !important;
}

.scoolct {
	height: 28rem;
	/deep/ .el-carousel {
		height: 100%;
		.el-carousel__container {
			position: inherit !important;
			height: 100% !important;
		}
	}
}

/* 滚动条整体样式 */
.scoolct::-webkit-scrollbar {
	width: 10px; /* 宽度 */
	height: 10px; /* 高度 */
}
/* 滚动槽 */
.scoolct::-webkit-scrollbar-track {
	background-color: #fff; /* 背景色 */
	border-radius: 5px; /* 圆角 */
}
/* 滚动条滑块 */
.scoolct::-webkit-scrollbar-thumb {
	background-color: #48da6a; /* 背景色 */
	border-radius: 5px; /* 圆角 */
}
/* 滚动条滑块悬停样式 */
.scoolct::-webkit-scrollbar-thumb:hover {
	background-color: #fff; /* 背景色 */
}

.staprelist {
	margin: 0 auto;
	width: 20%;
	padding: 20px;
	border-radius: 100px;
	cursor: pointer;
}
td,
tr,
th {
	text-align: center !important;
}
</style>
<template>
	<div>
		<titles titlename="考试详情" titlecontent="这里可以看到考试详情" :mbx="paths"></titles>

		<div id="pdf-container" style="width: 100%;height: 122vh;" ref="homes">
			<div class="classtitle">
				<div class="flexx" style="position: relative;">
					<img style="margin-left: 1rem;width: 100px;height: 100px;border-radius: 50%;" src="@/images/header.jpg" alt="" />
					<div class="classtitle1">
						<p class="classtitle1nem">{{ examinobj.SPA_PaperTitle }}</p>
						<div class="classnos">
							<div class="flexx">
								<p>考核专业：{{ examinobj.pro_name }}</p>
								<p>考核等级：{{ examinobj.IL_LevelTitle }}</p>
							</div>
							<div class="flexx">
								<p>考核岗位：{{ examinobj.PR_ProfessionalName }}</p>
								<p v-if="examinobj.SPA_SetExamTime != 'null'">考试时间：{{ examinobj.SPA_SetExamTime }}</p>
								<p v-else style="color: red;">考试时间：暂未派卷</p>
							</div>
						</div>
					</div>
					<p class="classnametiltle">考试详情</p>
					<div class="classtitle2" v-show="ispdfs"></div>
				</div>
				<div class="tablists flexx"><div ref="scrollTotablists1" :class="{ actives: isactives == 1 }" @click="changetablist(1)">实训考试详情列表</div></div>
			</div>

			<div class="classdatatotle">
				<div class="trainstitle flexx">
					<span style="display: block;width: 6px;height: 20px;margin-right: 10px;border-radius: 2px;background-color: #58A3F7;"></span>
					<p style="font-size: 1.2rem;font-weight: 600;">实训考试详情列表</p>
				</div>
				<el-table :data="tableData" style="width: 100%" :cell-style="{ 'text-align': 'center' }" :header-cell-style="{ 'text-align': 'center' }">
					<el-table-column type="index" width="50"></el-table-column>
					<el-table-column prop="ui_userName" label="姓名" width="120"></el-table-column>
					<el-table-column prop="cla_name" label="班级"></el-table-column>
					<el-table-column prop="SPA_PaperTitle" label="试卷名称"></el-table-column>
					<el-table-column prop="SSP_Scores" label="考试成绩" width="100">
						<template slot-scope="scope">
							<p v-if="scope.row.SSP_Scores != null">{{ scope.row.SSP_Scores }}</p>
							<p v-else style="color: red;">暂未开始考试</p>
						</template>
					</el-table-column>
					<el-table-column prop="address" label="交卷时间">
						<template slot-scope="scope">
							<p v-if="scope.row.SSP_Scores != null">{{ scope.row.SSP_EndTime }}</p>
							<p v-else style="color: red;">暂未开始考试</p>
						</template>
					</el-table-column>
					<el-table-column prop="address" label="考试用时(分钟)">
						<template slot-scope="scope">
							<p v-if="scope.row.SSP_Scores != null">{{ scope.row.SSP_TotalDuration }}</p>
							<p v-else style="color: red;">暂未开始考试</p>
						</template>
					</el-table-column>
					<el-table-column label="操作" fixed="right" width="300px">
						<template slot-scope="scope">
							<el-button v-if="scope.row.SSP_Scores != null" size="mini" style="background-color: #409eff;color: #fff;" @click="lookssresce(scope.row)">
								查看试卷
							</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="boxright" style="padding-bottom: 20px;">
					<!-- <el-button type="primary" @click="submitqutions()">确认添加</el-button> -->
					<el-pagination
						background
						@current-change="changechildpagesobj"
						layout="prev, pager, next"
						:page-size="childpagesobj.pageSize"
						:current-page="childpagesobj.pageIndex"
						:total="childtotalall"
					></el-pagination>
				</div>
			</div>

			<!-- <div class="classdatatotle">
				<div class="trainstitle flexx">
					<span style="display: block;width: 6px;height: 20px;margin-right: 10px;border-radius: 2px;background-color: #58A3F7;"></span>
					<p style="font-size: 1.2rem;font-weight: 600;">考试数据分析</p>
				</div>
				
			</div>
			 -->
		</div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';

import { SpaUserlist } from '@/request/api/homesview/yunhomes/yunhom.js';

import $ from 'jquery';
import AppOptions from '@/config/AppOptions.vue';
export default {
	data() {
		return {
			// 标题
			paths: [
				{
					path: '/textorexamin/examinationmanage/examinationmanage',
					name: '试卷管理'
				},
				{
					path: '/usercenter/myuserpromise',
					name: '考试详情'
				}
			],
			isactives: 1,
			ispdfs: true,
			examinobj: {},
			childpagesobj: {
				pageSize: 10,
				pageIndex: 1,
				SPA_GUID: ''
			},
			childtotalall: 0,
			tableData: []
		};
	},
	mounted() {
		this.examinobj = this.$route.query;
		this.childpagesobj.SPA_GUID = this.examinobj.SPA_GUID;
		this.get();
	},
	created() {
		AppOptions.appEmpty = false;
	},
	methods: {
		get() {
			SpaUserlist(this.childpagesobj).then(res => {
				this.tableData = res.data.data.list;
				this.childtotalall = res.data.data.totalCount;
			});
		},
		changechildpagesobj(val) {
			this.childpagesobj.pageIndex = val;
			this.get();
		},
		lookssresce(ite) {
			this.$router.push('/textorexamin/examinationmanage/examinxq?SPA_GUID=' + ite.SPA_GUID + '&UI_GUID=' + ite.ui_guid + '&SSP_Scores=' + ite.SSP_Scores);
		}
	},
	components: {
		titles
	}
};
</script>
